export default __webpack_public_path__ + "static/masthead-dev-suffix-e13bd2b6243a1030743f658fddab0071.png";